import React, { useState } from 'react';
import { ImgViewer } from '@core/components';

interface ThumbnailImgProps {
  imgPath: string;
  largeImgPath?: string | undefined;
  alt?: string | undefined;
  imgOptions?: {
    [key: string]: unknown;
  };
  viewFullscreen?: boolean;
  onThumbnailClick?: () => void;
}

const ThumbnailImg = ({
  imgPath,
  largeImgPath,
  alt,
  imgOptions = {},
  onThumbnailClick,
  viewFullscreen = true
}: ThumbnailImgProps) => {
  const [showFullscreen, setShowFullscreen] = useState(false);

  const onImgClick = () => {
    if (viewFullscreen) {
      setShowFullscreen(true);
    }

    if (onThumbnailClick) {
      onThumbnailClick();
    }
  };

  return (
    <>
      {showFullscreen && (
        <ImgViewer
          hideModal={() => setShowFullscreen(false)}
          imgPath={!largeImgPath ? imgPath : largeImgPath}
        />
      )}
      <div className="thumbnail-wrapper">
        <img
          className={`thumbnail ${
            !viewFullscreen && !onThumbnailClick ? 'thumbnail--no-click' : ''
          }`}
          role="presentation"
          src={imgPath}
          onClick={onImgClick}
          alt={alt || ''}
          {...imgOptions}
        />
      </div>
    </>
  );
};

export default ThumbnailImg;
